import { useEffect, useState } from 'react';
import { getSDK } from '@/store/sdkStore';
import { fileBase64 } from '@/lib/fileBytes';
import { createLogger } from '@/lib/logger';

const log = createLogger('fileImage');

// ============================================================================
// lib/widgets/fileImage.ts — ЕДИНЫЙ резолв картинки по id файла (SSoT/SRP):
// data URL через ПУБЛИЧНЫЕ RPC файлов (thumb → полный файл; гостевые права на
// справочник «Файлы»). Используется блоками сайтов (image/hero/фон/логотип) и
// списком записей сайта (карточка с изображением). Ошибка — явная (не тихий
// фоллбэк): картинка не выбрана/недоступна → понятный текст.
// ============================================================================

/** useFileImage — data URL картинки (thumb → полный файл; явная ошибка). */
export function useFileImage(fileId: string): { src: string; error: string } {
  const [src, setSrc] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    if (!fileId) { setSrc(''); setError(''); return; }
    (async () => {
      try {
        const sdk = getSDK();
        let data: Uint8Array | string | undefined;
        let type = 'image/png';
        try {
          const th = await sdk.files.getFileThumb({ id: fileId, width: 1600, momentMs: 1000 });
          data = th.data;
          type = th.fileType || type;
        } catch {
          const r = await sdk.files.downloadFile({ id: fileId });
          data = r.data;
          type = r.fileType || type;
        }
        if (!cancelled) setSrc(`data:${type};base64,${fileBase64(data)}`);
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : 'не удалось загрузить изображение');
          log.warn('не удалось получить изображение файла', { fileId, error: String(e) });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [fileId]);
  return { src, error };
}
